<template>
  <FullCalendar ref="refCalendar" :options="calendarOptions" />
</template>
<script>
import FullCalendar from '@fullcalendar/vue'
import dayGridPlugin from '@fullcalendar/daygrid'
import timeGridPlugin from '@fullcalendar/timegrid'
import interactionPlugin from '@fullcalendar/interaction'
import listPlugin from '@fullcalendar/list'
import esLocale from '@fullcalendar/core/locales/es';

export default {
    name: 'Calendar',
    components: {
        FullCalendar // make the <FullCalendar> tag available
    },
    data() {
        return {            
            calendarOptions: {
                //slotDuration: '24:00',     
                //height: "100%",
                locale: esLocale,           
                events: [],
                plugins: [
                    dayGridPlugin,
                    timeGridPlugin,
                    listPlugin,
                    interactionPlugin // needed for dateClick
                ],
                eventClick: this.handleEventClick,
                headerToolbar: {
                    left: 'prev,next today',
                    center: 'title',
                    right: 'dayGridMonth,listWeek'
                },
                initialView: 'listWeek',            
            visibleRange: function(currentDate) {
                // Generate a new date for manipulating in the next step
                var startDate = new Date(currentDate.valueOf());
                var endDate = new Date(currentDate.valueOf());

                // Adjust the start & end dates, respectively
                startDate.setDate(startDate.getDate() - 365); // One day in the past
                endDate.setDate(endDate.getDate() + 365); // Two days into the future

                return { start: startDate, end: endDate };
                }
            }
        }
    },
    methods: {
        handleEventClick: function(event) {
            var start = event.event.start;
            start = new Date(start.valueOf() - start.getTimezoneOffset() * 60000); 
            //Ajuste para GMT+1 / 0 entre la app y Nav
            this.$store.commit('saveDocumentDate',start);
            //if (event.event.title == 'Pulse para añadir un parte'){                
            if (event.event.extendedProps.newInput){
                //this.$store.state.dialogParte = true;
                this.$store.commit('resetDataAfterSuccessfulCreation');
                this.$router.push('Parte');
                this.$store.state.dialogConfirmDriver = true;
            } else {
                var docNo = event.event.extendedProps.inputNo;
                this.readDocument(docNo);
                //this.$store.state.dialogParteDetalle = true;
                this.$router.push('ParteDetalle');
            }
        }
    },
    watch:{
        eventos: function(val){
            
            var events = [];
            var today = new Date();                   
            var startDate = new Date(today.valueOf());
            //var sinceMonths = 5;
            var sinceMonths = 12;
            var sinceDays = sinceMonths*30;
            var toMonths = 2;
            var toDays = toMonths*30;
            startDate.setDate(startDate.getDate() - sinceDays);

            for (var i = 0; i <= sinceDays+toDays; i++){ 
                var eventDate = new Date(startDate); 
                eventDate.setDate(eventDate.getDate() + i);                    
                var backgroundColor = '';
                var textColor = '';
                var borderColor = '';
                if (i == sinceDays){ //Dia actual
                    backgroundColor = 'green';
                }
                var event = {
                    id: i, 
                    title: 'Pulse para añadir un parte', 
                    date: eventDate,                 
                    allDay: true, 
                    backgroundColor: backgroundColor, 
                    textColor: textColor,
                    borderColor: borderColor,
                    newInput : true
                }
                events.push(event);            
            }
            this.calendarOptions.events = events;
            if ((val != null) && (val != undefined) && (val.length > 0)){
                for (i = 0; i < val.length; i++){
                    var title = val[i].shipmentNo + ' | ' + val[i].inputNo;
                    if ((val[i].codProyecto != null ) && (val[i].codProyecto != 'null'))
                    {
                        title += ' | ' + val[i].codProyecto;
                    }
                    if (val[i].signedByCust){
                        title += ' 📝';
                    }
                    if (val[i].posted){
                        title += ' 🗃️';
                    }
                    if ((val[i].codProyecto != null ) && (val[i].codProyecto != 'null') && (val[i].vb)){
                        title += ' ✔️';
                    }
                    event = {
                        id: this.calendarOptions.events.length, 
                        title: title, 
                        date: val[i].creationDate,                 
                        allDay: true, 
                        backgroundColor: 'red',
                        inputNo : val[i].inputNo,
                        shipmentNo : val[i].shipmentNo,
                        newInput : false
                    }
                    this.calendarOptions.events.push(event);
                }
            }
        }
    },
    computed:{
        eventos:{
            get(){
                return this.$store.state.eventos;
            },
            set(value){
                this.$store.commit('saveEvents',value);
            }
        },
        refCalendar:{
            get(){
                return this.$store.state.refCalendar;
            },
            /*set(value){
                this.$store.commit('saveRefCalendar',value);
            }*/
        }
    },
    mounted(){
        /*var events = [];
        var today = new Date();
        var startDate = new Date(today.valueOf());
        startDate.setDate(startDate.getDate() - 3);
        for (var i = 0; i <= 15; i++){ 
            var eventDate = new Date(startDate); 
            eventDate.setDate(eventDate.getDate() + i);                    
            var backgroundColor = '';
            var textColor = '';
            var borderColor = '';
            if (i == 3){
                backgroundColor = 'green';
            }
            var event = {
                id: i, 
                title: 'Pulse para añadir un parte', 
                date: eventDate,                 
                allDay: true, 
                backgroundColor: backgroundColor, 
                textColor: textColor,
                borderColor: borderColor
            }
            events.push(event);            
        }*/
        this.$store.commit("saveResourcesAditional",[]);
        this.$store.commit('saveRefCalendar',this.$refs.refCalendar);
        this.getJobInputs();
        //this.calendarOptions.events = events;
    }
}
</script>
<style >
    .fc-list-event-time{display: none}
    .fc-toolbar-title{
        font-size: 10pt;
    }
    .fc .fc-toolbar-title{
        font-size: 0.7em;
    }
    .fc-event-today{
        background-color: bisque;
    }
</style>